<template>
  <div id="app" class="conteudo-app">
    <router-view></router-view>
  </div>
</template>

<script src="https://ui.digix.com.br/ativos/js/barra-navegacao.js"></script>
<script src="https://ui.digix.com.br/ativos/js/botao-hamburguer.js"></script>
<script>
/* eslint-disable */

if (process.env.NODE_ENV === 'production') {
  (function(h,o,t,j,a,r){
      h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
      h._hjSettings={hjid:167266,hjsv:5};
      a=o.getElementsByTagName('head')[0];
      r=o.createElement('script');r.async=1;
      r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
      a.appendChild(r);
  })(window,document,'//static.hotjar.com/c/hotjar-','.js?sv=');
}

export default {
  name: 'app',
};
</script>





// WEBPACK FOOTER //
// App.vue?214314b5